import React, { PureComponent } from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'

import Icon from '../../Atoms/Icon'
import Touchable from '../../Atoms/Touchable'

import { Text } from '../../Atoms/Typography'

import theme from '../../../styles/theme'

const Container = styled(View)`
width: 500px;
position: absolute;
left: 0;
top: 0;
display: flex;
padding: 10px 0 0 0;
z-index: 2;
`

const InnerContainer = styled(View)`
background: ${props => props.backgroundColour};
padding: ${theme.gutterUnit * 2}px;
border-radius: ${theme.gutterUnit}px;
border-color: ${theme.colours.bordergrey};
border-width: ${props => props.border ? '1px' : 0};
`

const CardHelpHeading = styled(View)`
width: 100%;
flex-direction: row;
justify-content: space-between;
padding-bottom: ${theme.gutterUnit}px;
`

export default class CardHelp extends PureComponent {
  render () {
    const { cardHelp: { isVisible, styles, heading, body, backgroundColour = theme.colours.lightgrey }, onCloseHandler, border } = this.props
    if (!isVisible) return null
    return (
      <Container style={styles}>
        <InnerContainer backgroundColour={backgroundColour} border={border}>
          <CardHelpHeading>
            <Text size='xl'>{heading}</Text>
            <Touchable onPress={onCloseHandler}>
              <Icon name='close' size='l' black />
            </Touchable>
          </CardHelpHeading>
          <Text size='m'>{body}</Text>
        </InnerContainer>
      </Container>
    )
  }
}
